import { Dialog, GenericSuspense, useUrlParamsValueToString, useTranslation } from "@bsm/component"
import { Outlet, useNavigate, useParams } from "react-router-dom"
import { useScholarityQuery } from "../hooks/useScholarityQuery"
import { ScholarityDetails } from "../components/ScholarityDetails"

export const ScholarityDetailsContainer = () => {

    const { scholarityId } = useParams()
    const urlParams = useUrlParamsValueToString()
    const { data } = useScholarityQuery(scholarityId ? parseInt(scholarityId) : undefined, true)
    const navigate = useNavigate()
    const t = useTranslation()

    return (
        <Dialog open title={'Scholarity details'} onClose={() => navigate(`..?${urlParams}`)}>
            <ScholarityDetails {...{ ...data, students: data.students?.filter((student) => !student.isEnrolled),}} />
            <GenericSuspense>
                <Outlet />
            </GenericSuspense>
        </Dialog>
    )
}
